import { Box, Button, styled, Typography } from "@mui/material"

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  flex: 1,
  paddingTop: 120,
})

export const MessageContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px",
})

export const Title = styled(Typography)({
  maxWidth: 280,
  margin: "30px 0 20px 0",
  textAlign: "center",
})

export const Subtitle = styled(Typography)({
  maxWidth: 313,
  textAlign: "center",
})

export const ActionButton = styled(Button)({
  minHeight: 54,
  width: "100%",
})
